import React from 'react';
import * as Styled from './styles';

export interface GenericModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  styles?: React.CSSProperties;
  fontStyles?: React.CSSProperties;
  showCloseButton?: boolean;
}

const GenericModal: React.FC<GenericModalProps> = ({ isOpen, onClose, title, children, styles, showCloseButton, fontStyles }) => {
  if (!isOpen) return null;

  return (
    <Styled.ModalOverlay>
      <Styled.ModalContainer role="dialog" aria-modal="true" style={{ ...styles }}>
        <Styled.ModalHeader>
          {title && <Styled.ModalTitle style={{ ...fontStyles }}>{title}</Styled.ModalTitle>}
          {showCloseButton && (
            <Styled.CloseModalButton onClick={onClose} aria-label="Close modal" data-automation="ModalCloseButton" type="button">
              <Styled.CloseButtonIcon />
            </Styled.CloseModalButton>
          )}
        </Styled.ModalHeader>
        {children}
      </Styled.ModalContainer>
    </Styled.ModalOverlay>
  );
};

GenericModal.defaultProps = {
  title: '',
  styles: {},
  fontStyles: {},
  showCloseButton: false,
};

export default GenericModal;
